import { all } from 'redux-saga/effects'
import CreateAccountSaga from '../pages/CreateAccount/sagas'
import AccountInfoSaga from '../pages/InfoPage/sagas'
import SmartCardSaga from '../pages/MainPage/sagas'

export default function* rootSaga() {
  yield all([SmartCardSaga(), AccountInfoSaga(), CreateAccountSaga()])
}
